// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"2bc9fb1c","534":"a2e8b2f5"}[chunkId] + ".chunk.js";
};